import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";

import type { TypeRoleName } from "../foundations/presets.js";
import { textStyles } from "./Text.styles.js";

/** The elements Text renders as. Headings are chosen by the page outline, never by the role. */
type TextElement = "p" | "span" | "div" | "h1" | "h2" | "h3" | "h4" | "label" | "strong" | "em";

export interface TextProps extends Omit<ComponentPropsWithoutRef<"span">, "color"> {
  /** A type role; the Figma text style of the same name (`Body/B2 Strong` → `body-b2-strong`). */
  variant?: TypeRoleName;
  tone?: NonNullable<Parameters<typeof textStyles>[0]>["tone"];
  /** The element; defaults to `p` for body roles and `span` for the rest. */
  as?: TextElement;
  children?: ReactNode;
}

/** Text in one of the theme's type roles. */
export function Text({ variant = "body-b1", tone, as, className, ...props }: TextProps) {
  const Element: ElementType = as ?? (variant.startsWith("body") ? "p" : "span");
  return <Element className={textStyles({ variant, tone, className })} {...props} />;
}
